<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">客户信息</span></div>
            <el-form :model="form" inline  style="padding-left:8px;margin-top:-20px;">
                <div style="display:flex;justify-content:flex-end;">
                    <el-button @click="onEditClick(null)" type="primary">新建客户</el-button>
                </div>                
                <el-row>
                    <el-form-item label="关键字">
						<el-input v-model="form.key" class="text-width"></el-input>
					</el-form-item>
                    <el-button @click="onQuery" type="primary">检索</el-button>
                </el-row>
            </el-form>
            <el-table 
                :data="clientList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="clientName" align="center" label="终端客户">
                    <template slot-scope="scope" >
                        <el-button type="text" @click="onEditClick(scope.row)">{{scope.row.clientName}}</el-button>
                    </template>
                </el-table-column>                
                <el-table-column prop="userName" align="center" width="130px" label="终端客户联络人" ></el-table-column> 
                <el-table-column prop="tel" align="center"  label="终端客户联络电话" ></el-table-column>
                <el-table-column prop="mail" align="center" label="终端客户电子邮件" ></el-table-column>
                <el-table-column prop="address" align="center"  label="终端客户地址" ></el-table-column> 
                <el-table-column prop="selfDefine" align="center"  label="自定义信息" >
                    <template slot-scope="scope" >
                        <el-button type="text" @click="onEditDefineClick(scope.row)">{{scope.row.selfDefine?scope.row.selfDefine:'无'}}</el-button>
                    </template>
                </el-table-column>     
                
                <el-table-column prop="clientName" align="center" width="80px" label="操作">
                    <template slot-scope="scope" >
                        <el-button type="text" @click="onLogListClick(scope.row)">跟进日志</el-button>
                        <el-button type="text" style="color:red;" @click="onDelClick(scope.row)">删除</el-button>
                    </template>
                </el-table-column>               
            </el-table>

                <div class="tabListPage">
                    <el-pagination @size-change="handleSizeChange" 
                                    @current-change="handleCurrentChange" 
                                    :current-page="currentPage" 
                                    :page-sizes="pageSizes" 
                                    :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                    :total="totalCount">
                        </el-pagination>
                </div>
           
                <!-- :data="doLog.slice((currentPage-1)*PageSize,currentPage*PageSize)"  -->

            <!-- <el-dialog title="服务日志" :visible="logDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="closeLogList" 
                            append-to-body>
                
            
		    </el-dialog> -->
            
            <el-dialog title="服务日志" v-if="logDialogVisible" :visible="logDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="logDialogVisible = false" 
                            append-to-body>                 
                         
                <history :cur-item="curItem" @close="logDialogVisible=false" @onDialogClose="setClose"/>                
            </el-dialog>


            <el-dialog title="新建/编辑客户" :visible="editDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="editDialogVisible = false" 
                            append-to-body>
                <el-form :model="clientForm" inline >
                    <el-row>
                        <el-form-item label="终端客户名称">
                            <el-input v-model="clientForm.clientName" class="text-width"></el-input>
                        </el-form-item>
                    </el-row>  
                                                          
            </el-form>
            <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                        <el-button @click="editDialogVisible = false">关闭</el-button>
                        <el-button style="margin-left:20px;" type="primary" @click="onSave">保存</el-button>
                    </div> 
            
		    </el-dialog>

            <el-dialog title="编辑自定义信息" :visible="editDefineDialogVisible" width="60%"
                            :modal-append-to-body='false'
                            :close-on-click-modal='false'
                            @close="editDefineDialogVisible = false" 
                            append-to-body>
                <el-form :model="clientForm" inline >
                    <el-row>
                        <el-form-item label="自定义信息">
                            <!-- <el-input v-model="defineForm.define" class="text-width"></el-input> -->
                            <el-input v-model="defineForm.define" size="medium" :rows="8" type="textarea"
                                    autocomplete="off" placeholder="请输入自定义信息" style="width:800px"
                                    ></el-input>
                        </el-form-item>
                    </el-row>  
                                                          
            </el-form>
            <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                        <el-button @click="editDefineDialogVisible = false">关闭</el-button>
                        <el-button style="margin-left:20px;" type="primary" @click="onSaveDefine">保存</el-button>
                    </div> 
            
		    </el-dialog>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { getLatestMonthDateArrayByDate } from "@/utils/time";
import { getToken } from "@/utils/auth";
import {ZC_SaveClient,ZC_DelClient,ZC_SaveClientDefine} from "@/api/zc";
import {getSampleArrayFromSever} from "@/utils/tools";
import History from './components/History.vue';

export default {
    name: 'baseform',
    components: {
        History
      },
    computed: {
        ...mapGetters(['clientList','resultList'])
    },
    data() {
        return {
            form: {    
                key:'',
            },

            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:50,

            editDialogVisible:false,
            editDefineDialogVisible:false,
            
            clientForm:{
                clientName:'',
            },
            defineForm:{
                define:'',
            },
            curItem:{},

            logDialogVisible:false,
        };
    },

    async mounted() {
        this.onQuery();
    },


    methods: {
        async onEditDefineClick(item){
            this.curItem=item;   
            this.defineForm.define=item.selfDefine;         
            this.editDefineDialogVisible=true;
        },

        async onLogListClick(item){
            // this.doLog=[];
            // this.orderCodeList=[];
            this.curItem=item; 
            this.curItem.isAgent=0;  
            // // [{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]
            // await this.$store.dispatch('zc/resultList',{companyId:item.id}).then(()=>{
            //     this.resultList.forEach(ele=>{
            //         var obj={};
            //         var samples = ele.samples;
            //         obj=ele;
            //         obj.sampleArr=getSampleArrayFromSever({samples});
            //         this.doLog.push(obj);
            //     });
            //     const map = new Map()
            //     var list = this.resultList.filter(key => !map.has(key.订单编号) && map.set(key.订单编号, 1)) // 这里对 订单编号 属性进行去重
            //     // console.log('this.orderCodeList',this.orderCodeList)
            //     list.forEach(ele => {
            //         this.orderCodeList.push({text:ele.订单编号,value:ele.订单编号});
            //     });
            //     this.logDialogVisible=true;
                
            // });     
            this.logDialogVisible=true;
        },

        
        setClose(){
            this.logDialogVisible=false;
        },
        

        async onEditClick(item){
            if (item){
                this.clientForm.clientName=item.clientName;
                this.curItem=item;
            }else{
                this.clientForm.clientName='';
                this.curItem={};
            }
            this.editDialogVisible=true;
        },

       async onQuery(){
        // console.log('form',this.form)
        const {key} = this.form;
        
        await this.$store.dispatch("zc/clientList", {
            key,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.clientList.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },

        

        
        async onSave(){
            const {clientName} = this.clientForm;
            if(!clientName){
                this.$message.warning('请输入终端客户名称');
                return;
            }
            //console.log('aaa',this.curItem)
            var id ='';
            if (this.curItem && this.curItem.id){
                console.log('ss')
                id=this.curItem.id;
            }
           
            await ZC_SaveClient({userId: getToken(),id,clientName:this.clientForm.clientName}).then(()=>{
                this.onQuery();
                this.$message.success('保存成功');
                this.editDialogVisible=false;
            });
        },

        async onSaveDefine(){
            const {define} = this.defineForm;
            // if(!clientName){
            //     this.$message.warning('请输入终端客户名称');
            //     return;
            // }
            // console.log('aaa',this.curItem)
            var id ='';
            if (this.curItem && this.curItem.id){
                // console.log('ss')
                id=this.curItem.id;
            }
           
            await ZC_SaveClientDefine({userId: getToken(),id,define:this.defineForm.define}).then(()=>{
                this.onQuery();
                this.$message.success('保存成功');
                this.editDefineDialogVisible=false;
            });
        },

        async onDelClick(item){
            this.$confirm('是否确认删除？ 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {    
                        await ZC_DelClient({userId: getToken(),id:item.id}).then(()=>{
                        this.onQuery();              
						this.$message.success('删除成功');
					})
                    })

           
        },
    }
};
</script>

<style scoped>
</style>